import _get from "lodash/get";
import { getInstitution, getProduct } from './common';
/**
 * Get the URL of the logo.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The logo URL
 */

export var getImageSrc = function getImageSrc(marketplaceEntity) {
  return _get(getInstitution(marketplaceEntity), 'details.logo_url.value');
};
/**
 * Get the logo alt text.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The alt text for the logo.
 */

export var getImageAltText = function getImageAltText(marketplaceEntity) {
  return getIssuerName(marketplaceEntity);
};
/**
 * Get the issuer name.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The review link.
 */

export var getIssuerName = function getIssuerName(marketplaceEntity) {
  return _get(getInstitution(marketplaceEntity), 'details.name.value');
};
/**
 * Get the issuer review link.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The review link.
 */

export var getIssuerReviewLink = function getIssuerReviewLink(marketplaceEntity) {
  return _get(getInstitution(marketplaceEntity), 'details.review_url.value');
};
/**
 * Get the "learn more" / review link.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The "learn more" / review link.
 */

export var getLearnMoreLink = function getLearnMoreLink(marketplaceEntity) {
  return getProductReviewLink(marketplaceEntity);
};
/**
 * Get the product review link.
 * @param {Object} marketplaceEntity The marketplace entity
 * @return {string} The review link.
 */

export var getProductReviewLink = function getProductReviewLink(marketplaceEntity) {
  return _get(getProduct(marketplaceEntity), 'details.review_url.value');
};
/**
 * Get the name of the product / service provided.
 * @param {Object} marketplaceEntity The marketplace entity
 * @returns {String} The name
 */

export var getName = function getName(marketplaceEntity) {
  return _get(marketplaceEntity, 'details.name.value');
};